// Menu.js - Fixed version with proper overlay click handling
import "./Menu.css";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

function Menu({ loggedIn, isDark, setIsDark, onLogout }) {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const menuRef = useRef(null);

  // Check screen size on resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setIsMenuOpen(false); // Close menu when switching to desktop
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close menu when route changes (mobile only)
  useEffect(() => {
    if (isMobile) {
      setIsMenuOpen(false);
    }
  }, [location.pathname, isMobile]);

  // Handle click outside to close menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobile &&
        isMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        // Don't close if clicking on hamburger button
        if (!event.target.closest(".hamburger")) {
          setIsMenuOpen(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobile, isMenuOpen]);

  const changeTheme = () => {
    console.log("theme change");
    setIsDark(!isDark);
  };

  const handleLogout = () => {
    onLogout();
    if (isMobile) setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      {/* Hamburger button - only visible on mobile */}
      <button
        className={`hamburger ${isMenuOpen ? "active" : ""}`}
        onClick={toggleMenu}
        aria-label='Menu'
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Overlay for mobile menu */}
      {isMobile && isMenuOpen && (
        <div className='menu-overlay' onClick={closeMenu}></div>
      )}

      <nav
        ref={menuRef}
        className={`navigation ${isMobile ? "mobile" : ""} ${isMenuOpen ? "open" : ""}`}
      >
        <ul className='navigation__list'>
          <li className='navigation__list-item'>
            <Link
              className={location.pathname === "/memarts" ? "active" : ""}
              to='/memarts'
              onClick={closeMenu}
            >
              MemArts
            </Link>
          </li>
          <li className='navigation__list-item'>
            <Link
              className={location.pathname === "/guess" ? "active" : ""}
              to='/guess'
              onClick={closeMenu}
            >
              Guessing game
            </Link>
          </li>
          <li className='navigation__list-item'>
            <Link
              className={location.pathname === "/hangman" ? "active" : ""}
              to='/hangman'
              onClick={closeMenu}
            >
              Hangman
            </Link>
          </li>
          {loggedIn && (
            <li className='navigation__list-item'>
              <Link
                className={location.pathname === "/phonetics" ? "active" : ""}
                to='/phonetics'
                onClick={closeMenu}
              >
                Phonetics
              </Link>
            </li>
          )}
          <li className='navigation__list-item auth-buttons'>
            {!loggedIn ? (
              <>
                <Link
                  to='/login'
                  className='auth-btn login-btn'
                  onClick={closeMenu}
                >
                  Login
                </Link>
                <Link
                  to='/register'
                  className='auth-btn register-btn'
                  onClick={closeMenu}
                >
                  Register
                </Link>
              </>
            ) : (
              <>
                <Link
                  to='/dashboard'
                  className='auth-btn login-btn'
                  onClick={closeMenu}
                >
                  Dashboard
                </Link>
                <button
                  className='auth-btn logout-btn'
                  onClick={handleLogout}
                  aria-label='Logout'
                >
                  Log out
                </button>
              </>
            )}
          </li>
          <li className='navigation__list-item theme-btn-wrapper'>
            <button
              className='theme-btn'
              onClick={changeTheme}
              aria-label='Switch theme'
            >
              {isDark ? "🌙" : "☀️"}
            </button>
          </li>
        </ul>
      </nav>
    </>
  );
}

export default Menu;
